import useMonolithApiQuery, { UseMonolithApiQueryOptions } from '@/hooks/api/useMonolithApiQuery';

export type CreditInfo = { total: string; resetDate: string; canUpgrade: { permission: boolean; selfServe: boolean } };
type FixerStatus =
  | {
      fixerStatus: 'out-of-credits';
      creditInfo: CreditInfo;
    }
  | { fixerStatus: 'enabled' | 'disabled' };

export type AIAssistantResponseType = {
  failureInfo: {
    failureReason: string;
    failureDescription: string;
    stepExecutionId?: string;
    stepId?: string;
    stepTitle?: string;
    isFixableByAgent: boolean;
    notFixableByAgentReason: string;
  };
} & FixerStatus;

export const getAIAssistanResultPath = (build_slug: string) => {
  return `/api/builds/${build_slug}/ai_assistant_result`;
};

const useBuildAIAssistantResult = (
  buildSlug: string,
  opts: UseMonolithApiQueryOptions<AIAssistantResponseType, unknown>,
) =>
  useMonolithApiQuery<AIAssistantResponseType, unknown>(
    ['ai-assistant', buildSlug],
    getAIAssistanResultPath(buildSlug),
    opts,
  );

export default useBuildAIAssistantResult;
